import { FunctionComponent, useContext, useEffect } from 'react';
import { InterestProvidersListFilters } from './interest-providers-list-filters';
import { InterestProviderListItems } from './';
import { InterestProvidersContext } from './context';
import { isAllowedUrl } from './utils';
import { useIntl } from 'react-intl';

interface Props {
  id?: string | null;
}

export const InterestProvidersList: FunctionComponent<Props> = ({ id }) => {
  const { hideList } = useContext(InterestProvidersContext);
  const intl = useIntl();

  useEffect(() => {
    if (!isAllowedUrl(window.location.href)) {
      window.location.href =
        intl.locale === 'nl' ? '/rentestanden/' : '/en/mortgage-interest-rates/';
    }
  }, []);
  return (
    <div className={`md:p-0 w-full`}>
      <div className={`mb-4 md:mb-16 ${hideList && 'h-[650px]'}`}>
        <InterestProvidersListFilters date={id || 'niet bekend'}></InterestProvidersListFilters>
      </div>
      {!hideList && <InterestProviderListItems></InterestProviderListItems>}
    </div>
  );
};
